import { render, staticRenderFns } from "./shopcategorylist.vue?vue&type=template&id=e9e37fb4&scoped=true&"
import script from "./shopcategorylist.vue?vue&type=script&lang=js&"
export * from "./shopcategorylist.vue?vue&type=script&lang=js&"
import style0 from "./shopcategorylist.vue?vue&type=style&index=0&id=e9e37fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e37fb4",
  null
  
)

export default component.exports